import {autoserializeAs, autoserializeAsArray} from "dcerialize";
import {NewsAuthor} from "./NewsAuthor";
import {Tag} from "../Tag";

export class NewsContent {
  @autoserializeAs(() => String)
  public readonly html: string;
}

export class NewsEntry {
  @autoserializeAs(() => Number)
  public readonly id: number;
  @autoserializeAs(() => String)
  public readonly title: string;
  @autoserializeAs(() => String)
  public readonly slug: string;
  @autoserializeAs(() => NewsContent)
  public readonly content: Readonly<NewsContent>;
  @autoserializeAs(() => NewsAuthor)
  public readonly author: Readonly<NewsAuthor>;
  @autoserializeAsArray(() => Tag)
  public readonly tags: readonly Tag[];
  @autoserializeAs(() => Date)
  public readonly createdAt: Date;
  @autoserializeAs(() => Date)
  public readonly updatedAt?: Date;
}
